import { resetConsent } from './CookieConsent/consent';

const currentYear = new Date().getFullYear();

const legalLinkStyle = {
    color: 'var(--sb-ink-muted)',
    textDecoration: 'underline'
};

// Matches the anchors around it so withdrawing consent is no harder to find
// than the links to the documents themselves.
const consentButtonStyle = {
    ...legalLinkStyle,
    background: 'none',
    border: 'none',
    padding: 0,
    font: 'inherit',
    cursor: 'pointer'
};

/**
 * App-wide footer attributing the service to its operating legal entity.
 * Para Labs LLC owns and operates the usevixo.com product.
 */
export function Footer() {
    return (
        <footer
            style={{
                // The app shell (.app-container) is a flex column; .container
                // grows (flex:1 0 auto) to push this footer to the bottom.
                // flexShrink:0 keeps the footer at full height. NOTE: do not use
                // marginTop:auto here — an auto margin suppresses the sibling
                // .container's flex-grow, which let tall pages overflow and the
                // footer render mid-content.
                flexShrink: 0,
                padding: '16px 12px',
                textAlign: 'center',
                fontSize: '12px',
                lineHeight: 1.5,
                color: 'var(--sb-ink-muted)',
                borderTop: '1px solid #e5e7eb'
            }}
        >
            <div style={{ marginBottom: '6px' }}>
                {/* Plain anchors, not router links: the footer renders on
                    signed-out screens that are outside AuthenticatedApp's
                    BrowserRouter. App Store and OAuth reviews also expect the
                    policy links to be reachable from the homepage. */}
                <a href="/terms" style={legalLinkStyle}>Terms of Service</a>
                <span aria-hidden="true" style={{ margin: '0 8px', color: 'var(--sb-ink-2)' }}>|</span>
                <a href="/privacy" style={legalLinkStyle}>Privacy Policy</a>
                <span aria-hidden="true" style={{ margin: '0 8px', color: 'var(--sb-ink-2)' }}>|</span>
                {/* Re-opens the cookie banner. GDPR requires withdrawing
                    consent to be as easy as giving it, so this stays visible
                    permanently rather than only before a choice is made. */}
                <button type="button" style={consentButtonStyle} onClick={resetConsent}>
                    Cookie preferences
                </button>
            </div>
            <div>usevixo.com is a product of, and operated by, Para Labs LLC.</div>
            <div>&copy; {currentYear} Para Labs LLC. All rights reserved.</div>
        </footer>
    );
}

export default Footer;
